import { Box, Tooltip } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { useParams } from "react-router"
import { navigateScheduleEditor } from "../../utilities/project-navigation"
import { DraftStatus } from "authoring/lib/enum/draft-status.mjs"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { AUTHORING_EDIT_SCHEDULES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function EditSchedule() {
    const { projectId } = useParams()
    const { targetId: scheduleId, status, target } = useBoundContext()
    const sentToLegacy = isLockedToLegacy(target?.phase)
    const archived = !!target?.archived

    let disabledMessage = ""
    const disabled = status === DraftStatus.SUBMITTED || status === DraftStatus.APPROVED || sentToLegacy || archived
    if (status === DraftStatus.SUBMITTED) disabledMessage = "A draft cannot be edited after it was submitted for review"
    if (status === DraftStatus.APPROVED) disabledMessage = "A draft cannot be edited after the review was approved"
    if (sentToLegacy) disabledMessage = "A draft cannot be edited after it was sent to legacy"
    if (archived) disabledMessage = "An archived work package is read only"

    return (
        <Secure demand={AUTHORING_EDIT_SCHEDULES_DEMAND} fallback={<Frag />}>
            <Tooltip
                title={disabled ? disabledMessage : ""}
                slotProps={{
                    popper: {
                        sx: {
                            zIndex: 2002,
                        },
                    },
                }}
            >
                <Box>
                    <ContextMenuItem
                        icon="clarity:edit-solid"
                        label="Edit"
                        onClick={() => navigateScheduleEditor({ projectId, scheduleId })}
                        disabled={disabled}
                    />
                </Box>
            </Tooltip>
        </Secure>
    )
}
